var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoris(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Element_24/Fav/Full/Blanc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.944,20.171 C16.785,20.171 16.625,20.133 16.479,20.056 L12,17.702 L7.521,20.056 C7.186,20.233 6.776,20.204 6.468,19.98 C6.16,19.757 6.006,19.377 6.07,19.002 L6.926,14.015 L3.302,10.483 C3.029,10.217 2.932,9.82 3.049,9.458 C3.167,9.096 3.479,8.832 3.856,8.777 L8.864,8.05 L11.104,3.512 C11.439,2.829 12.561,2.829 12.896,3.512 L15.136,8.05 L20.144,8.777 C20.521,8.832 20.833,9.096 20.951,9.458 C21.068,9.82 20.971,10.217 20.698,10.483 L17.074,14.015 L17.93,19.002 C17.994,19.377 17.84,19.757 17.532,19.98 C17.358,20.107 17.151,20.171 16.944,20.171",
    id: "Path",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoris);
export default __webpack_public_path__ + "static/media/favoris.fd82cb4eed741352aee5636e51863bd2.svg";
export { ForwardRef as ReactComponent };